<script lang="ts">
    import Router from 'svelte-spa-router';
    import Login from "./pages/Login.svelte";
    import {link} from 'svelte-spa-router'
    import Logout from "./pages/Logout.svelte";

    let routes = {
        '/': Login,
        '/login': Login,
        '/logout': Logout,
    }


</script>

<body>

<Router {routes}>
</Router>
</body>
